







































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { getCurrentCompanyId } from "@/plugins/roles";
import { getDocumentGeneratorApiMethodByType } from "@/utils/document-generator-helper";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import CFileManager from "@/components/fileManager/CFileManager.vue";
import DocTemplateVariables from "@/components/doc-tempates/DocTemplateVariables.vue";
import { TemplateFile as ITemplateFile } from "@/api-v2/document-generator/models/template-file";
import { FileItem as IFileItem } from "@/api/models";
import { Variable as IVariable } from "@/api-v2/document-generator/models/variable";
import {
  TemplateFileCreate as ITemplateFileCreate,
  TemplateFileCreateContextEnum
} from "@/api-v2/document-generator/models/template-file-create";

@Component({
  components: {
    DocTemplateVariables,
    CFileManager,
    Modal,
    CustomButton,
    CBlock,
    CField
  }
})
export default class DocTemplateFormV2 extends Vue {
  @Prop({ default: false }) isLoading?: boolean;
  @Prop() template?: ITemplateFile;
  isTemplateLoading: boolean = false;
  title: string = "";
  type: TemplateFileCreateContextEnum = TemplateFileCreateContextEnum.Contract;
  showFileManager: boolean = false;
  selectedFile!: IFileItem;
  variables: IVariable[] = [];

  data() {
    return {
      selectedFile: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get types() {
    return TemplateFileCreateContextEnum;
  }

  async getTemplateValue() {
    const method = getDocumentGeneratorApiMethodByType(this.type);
    try {
      this.isTemplateLoading = true;
      if (method) {
        this.variables = [];
        const { data } = await method;
        this.variables = data;
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isTemplateLoading = false;
    }
  }

  save() {
    if (this.selectedFile) {
      const template: ITemplateFileCreate = {
        companyId: this.companyId,
        fileId: this.selectedFile?.id,
        title: this.title,
        context: this.type
      };
      this.$emit("onSave", template);
    } else {
      this.$bvToast.toast(`${this.$t(this.$translate.FileNotSelected)}`, {
        variant: "danger",
        title: `${this.$t(this.$translate.Error)}`
      });
    }
  }

  getFile(item: IFileItem) {
    if (
      item.mimeType !==
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      this.$bvToast.toast("Не верный формат документа, разрешен только docx", {
        variant: "danger",
        title: `${this.$tc(this.$translate.Error)}`
      });
    } else {
      this.selectedFile = item;
      this.showFileManager = false;
    }
  }

  getFileName(url: string) {
    const chunks = url?.split("/");
    return chunks[chunks?.length - 1] ?? url;
  }

  created() {
    if (this.template) {
      this.type = (this.template
        ?.context as unknown) as TemplateFileCreateContextEnum;
      this.title = this.template?.title;
      this.selectedFile = {
        id: this.template?.fileId,
        name: this.getFileName(this.template.url),
        url: this.template?.url
      } as any;
    }
    this.getTemplateValue();
    this.detectRoutePathEntityName();
  }

  detectRoutePathEntityName() {
    if (this.$route.query.entity === "expulsion-order") {
      this.type = TemplateFileCreateContextEnum.ExpulsionOrder;
    }
    if (this.$route.query.entity === "act") {
      this.type = TemplateFileCreateContextEnum.Act;
    }
    if (this.$route.query.entity === "bill") {
      this.type = TemplateFileCreateContextEnum.Bill;
    }
    if (this.$route.query.entity === "contract") {
      this.type = TemplateFileCreateContextEnum.Contract;
    }
    if (this.$route.query.entity === "final-document") {
      this.type = TemplateFileCreateContextEnum.FinalDocument;
    }
    if (this.$route.query.entity === "enrollment-order") {
      this.type = TemplateFileCreateContextEnum.EnrollmentOrder;
    }
    if (this.$route.query.entity === "education-protocol") {
      this.type = TemplateFileCreateContextEnum.EducationProtocol;
    }
  }
}
